module.exports = __webpack_public_path__ + "static/img/yiNew5.fa41e20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/yiNew5.jpg
// module id = lr5E
// module chunks = 0